
import angular from 'angular';

import { HorarioDetalhadoModalService } from './modais/modal-horario-detalhado/horario-detalhado.modal.service';
import { VinculoCpfModalService } from './modais/modal-vinculo-cpf/vinculo-cpf.modal.service';

export const MeurhAdmissaoModule = angular.module('MeurhAdmissaoModule', ['ui.router.state', ])
    .service('HorarioDetalhadoModalService', HorarioDetalhadoModalService)
    .service('VinculoCpfModalService', VinculoCpfModalService)
    .name;
